export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}

	const { order, injured, setting } = this
	let arr = []

	arr.push(
		{
			label: '派单公司',
			value: order.company,
		},
		{
			label: '报案号',
			value: order.caseNo,
		},
		{
			label: '订单号',
			value: order.orderNo,
		},
		{
			label: '所属地区',
			value: order.fullDesc,
		},
		{
			label: '任务类型',
			value: setting.lawsuitTasktypeMap[order.taskType],
		},
		{
			label: '案件负责人姓名',
			value: order.contact,
		},
		{
			label: '案件负责人电话',
			value: order.contactPhone,
		}
	)
	if (order.cancelReason) {
		arr.push({
			label: '撤单原因',
			value: order.cancelReason,
		})
	}
	return {
		title: '任务信息',
		children: arr,
	}
}
